import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

// Modules Material utilises
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

// Autres modules externes utilises 
import {
	NgxMatNativeDateModule,
	NgxMatTimepickerModule
} from '@angular-material-components/datetime-picker';

// Modules metiers utilises
import { AgenceModule } from '../structure/agence/agence.module';
import { AntenneModule } from '../structure/antenne/antenne.module';
import { ParcModule } from '../structure/parc/parc.module';
import { UserModule } from '../humain/user/user.module';

// Modules communs utilises
import { BootstrapPopupModule } from '../../shared/bootstrap-popup/bootstrap-popup.module';
import { CheckboxListModule } from '../../shared/checkbox-list/checkbox-list.module';
import { DialogsModule } from '../../shared/dialogs/dialogs.module';
import { FilterableSelectModule } from '../../shared/filterable-select/filterable-select.module';
import { JSR310LocalDatesModule } from '../../shared/jsr310-localdates/jsr310-localdates.module';
import { PannelModule } from '../../shared/pannel/pannel.module';
import { SuggestableInputModule }  from '../../shared/suggestable-input/suggestable-input.module';

// Composants metiers
import { BasicTimepickerComponent } from './components/basic-timepicker.component';
import { CreateMessageCollationneDialogComponent } from './components/create-message-collationne-dialog.component';
import { EmetteurCheckboxListComponent } from './components/emetteur-checkbox-list.component';
import { MessagesCollationnesComponent } from './components/messages-collationnes.component';
import { MessagesCollationnesFiltersComponent } from './components/messages-collationnes-filters.component';
import { MessagesCollationnesTableComponent } from './components/messages-collationnes-table.component';
import { ViewMessageCollationneDialogComponent } from './components/view-message-collationne-dialog.component';

// Services metier
import { MessageCollationneService } from './services/message-collationne.service';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		
		MatPaginatorModule,
		MatProgressBarModule,
		MatSortModule,
		MatTableModule,

		NgxMatNativeDateModule,
		NgxMatTimepickerModule,
		
		AgenceModule,
		AntenneModule,
		ParcModule,
		UserModule,
		
		BootstrapPopupModule,
		CheckboxListModule,
		DialogsModule,
		FilterableSelectModule,
		JSR310LocalDatesModule,
		PannelModule,
		SuggestableInputModule,
	],
	providers: [
		MessageCollationneService,
	],
	declarations: [
		BasicTimepickerComponent,
		
		EmetteurCheckboxListComponent,
		
		CreateMessageCollationneDialogComponent,
		MessagesCollationnesComponent,
		MessagesCollationnesFiltersComponent,
		MessagesCollationnesTableComponent,
		ViewMessageCollationneDialogComponent,
	],
	entryComponents: [
		MessagesCollationnesComponent,
	]
})
export class MessageCollationneModule {
	constructor() { }
}